function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

module.exports = function (e) {
  var r = {};

  function t(n) {
    if (r[n]) return r[n].exports;
    var o = r[n] = {
      i: n,
      l: !1,
      exports: {}
    };
    return e[n].call(o.exports, o, o.exports, t), o.l = !0, o.exports;
  }

  return t.m = e, t.c = r, t.d = function (e, r, n) {
    t.o(e, r) || Object.defineProperty(e, r, {
      enumerable: !0,
      get: n
    });
  }, t.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, t.t = function (e, r) {
    if (1 & r && (e = t(e)), 8 & r) return e;
    if (4 & r && "object" == _typeof(e) && e && e.__esModule) return e;
    var n = Object.create(null);
    if (t.r(n), Object.defineProperty(n, "default", {
      enumerable: !0,
      value: e
    }), 2 & r && "string" != typeof e) for (var o in e) {
      t.d(n, o, function (r) {
        return e[r];
      }.bind(null, o));
    }
    return n;
  }, t.n = function (e) {
    var r = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return t.d(r, "a", r), r;
  }, t.o = function (e, r) {
    return Object.prototype.hasOwnProperty.call(e, r);
  }, t.p = "", t(t.s = 13);
}({
  0: function _(e, r) {
    e.exports = require("react");
  },
  1: function _(e, r, t) {
    e.exports = t(53)();
  },
  10: function _(e, r, t) {
    var n;
    !function () {
      "use strict";

      var t = {}.hasOwnProperty;

      function o() {
        for (var e = [], r = 0; r < arguments.length; r++) {
          var n = arguments[r];

          if (n) {
            var i = _typeof(n);

            if ("string" === i || "number" === i) e.push(n);else if (Array.isArray(n) && n.length) {
              var a = o.apply(null, n);
              a && e.push(a);
            } else if ("object" === i) for (var u in n) {
              t.call(n, u) && n[u] && e.push(u);
            }
          }
        }

        return e.join(" ");
      }

      void 0 !== e && e.exports ? (o.default = o, e.exports = o) : void 0 === (n = function () {
        return o;
      }.apply(r, [])) || (e.exports = n);
    }();
  },
  11: function _(e, r, t) {
    "use strict";

    Object.defineProperty(r, "__esModule", {
      value: !0
    });

    r.default = function (e, r, t) {
      var n = Object.keys(r),
          o = t && t.handleMissingStyleName || "throw";
      return e.split(" ").filter(function (e) {
        return e;
      }).map(function (e) {
        if (function (e) {
          return -1 !== e.indexOf(".");
        }(e)) return function (e, r, t) {
          var n = e.split("."),
              o = n[0],
              i = n[1],
              a = t || "throw";

          if (!i) {
            if ("throw" === a) throw new Error("Invalid style name: " + e);
            if ("warn" !== a) return null;
          }

          if (!r[o]) {
            if ("throw" === a) throw new Error("CSS module import does not exist: " + o);
            if ("warn" !== a) return null;
          }

          if (!r[o][i]) {
            if ("throw" === a) throw new Error("CSS module does not exist: " + i);
            if ("warn" !== a) return null;
          }

          return r[o][i];
        }(e, r, o);
        if (0 === n.length) throw new Error("Cannot use styleName attribute for style name '" + e + "' without importing at least one stylesheet.");
        if (n.length > 1) throw new Error("Cannot use anonymous style name '" + e + "' with more than one stylesheet import.");
        var t = r[n[0]];
        if (!t[e] && "throw" === o) throw new Error("Could not resolve the styleName '" + e + "'.");
        return t[e];
      }).filter(function (e) {
        return e;
      }).join(" ");
    };
  },
  13: function _(e, r, t) {
    "use strict";

    t.r(r);
    var n = t(11),
        o = t.n(n),
        i = t(0),
        a = t.n(i),
        u = t(1),
        s = t.n(u),
        l = t(10),
        c = t.n(l),
        f = (t(182), function () {
      function e(e, r) {
        for (var t = 0; t < r.length; t++) {
          var n = r[t];
          n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
        }
      }

      return function (r, t, n) {
        return t && e(r.prototype, t), n && e(r, n), r;
      };
    }()),
        p = {
      "./styles.scss": {
        "c-icon": "wri_api__c-icon",
        "-tiny": "wri_api__-tiny",
        "-smaller": "wri_api__-smaller",
        "-small": "wri_api__-small",
        "-medium": "wri_api__-medium",
        "-big": "wri_api__-big",
        "-huge": "wri_api__-huge",
        "-star": "wri_api__-star"
      }
    };

    var _ = function (e) {
      function r() {
        return function (e, r) {
          if (!(e instanceof r)) throw new TypeError("Cannot call a class as a function");
        }(this, r), function (e, r) {
          if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return !r || "object" != _typeof(r) && "function" != typeof r ? e : r;
        }(this, (r.__proto__ || Object.getPrototypeOf(r)).apply(this, arguments));
      }

      return function (e, r) {
        if ("function" != typeof r && null !== r) throw new TypeError("Super expression must either be null or a function, not " + _typeof(r));
        e.prototype = Object.create(r && r.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), r && (Object.setPrototypeOf ? Object.setPrototypeOf(e, r) : e.__proto__ = r);
      }(r, a.a.PureComponent), f(r, [{
        key: "render",
        value: function value() {
          var e,
              r,
              t,
              n = this.props,
              i = n.name,
              u = n.className,
              s = n.style,
              l = c()((t = !!u, (r = u) in (e = {}) ? Object.defineProperty(e, r, {
            value: t,
            enumerable: !0,
            configurable: !0,
            writable: !0
          }) : e[r] = t, e));
          return a.a.createElement("svg", {
            style: s,
            className: o()("c-icon " + l, p)
          }, a.a.createElement("use", {
            xlinkHref: "#" + i
          }));
        }
      }]), r;
    }();

    _.propTypes = {
      name: s.a.string,
      className: s.a.string,
      style: s.a.object
    }, _.defaultProps = {
      name: "",
      className: "",
      style: {}
    }, r.default = _;
  },
  182: function _(e, r, t) {
    e.exports = {
      "c-icon": "wri_api__c-icon",
      "-tiny": "wri_api__-tiny",
      "-smaller": "wri_api__-smaller",
      "-small": "wri_api__-small",
      "-medium": "wri_api__-medium",
      "-big": "wri_api__-big",
      "-huge": "wri_api__-huge",
      "-star": "wri_api__-star"
    };
  },
  53: function _(e, r, t) {
    "use strict";

    var n = t(54);

    function o() {}

    e.exports = function () {
      function e(e, r, t, o, i, a) {
        if (a !== n) {
          var u = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
          throw u.name = "Invariant Violation", u;
        }
      }

      function r() {
        return e;
      }

      e.isRequired = e;
      var t = {
        array: e,
        bool: e,
        func: e,
        number: e,
        object: e,
        string: e,
        symbol: e,
        any: e,
        arrayOf: r,
        element: e,
        instanceOf: r,
        node: e,
        objectOf: r,
        oneOf: r,
        oneOfType: r,
        shape: r,
        exact: r
      };
      return t.checkPropTypes = o, t.PropTypes = t, t;
    };
  },
  54: function _(e, r, t) {
    "use strict";

    e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  }
});